/* ==================================================
#Featured collection
#Featured promotions
#Slideshow
#Testimonials
#Gallery
#Video
#Cart
#Product
#Header
#Social media
#Map
#FAQ

/*============================================================================
  Featured collection
==============================================================================*/

var featuredCollectionSection = {
  init: function(){
    $('.product-thumbnail-card').hover(function(event) {
      if(!$(this).find('#feature-video video')[0]) return
      $(this).find('#feature-video video')[0].pause()
    },function(event){
      if(!$(this).find('#feature-video video')[0]) return
      $(this).find('#feature-video video')[0].play()
    })
    $('#feature-video video').ready(function(event) {
      $('#feature-video video')[0] && $('#feature-video video')[0].play()
    })
    $('.js-product-slider .products-slider').each(function (index, value) {
      var products_per_slide = $(this).data('products-per-slide');
      var products_limit = $(this).data('products-limit');
      var products_available = $(this).data('products-available');
      var cellAlign,
          draggable,
          prevNext,
          wrapAround,
          initialIndex;

      if (products_per_slide == "2" && products_available > products_per_slide && products_limit > products_per_slide || products_per_slide == "4" && products_available > products_per_slide && products_limit > products_per_slide || products_per_slide == "6" && products_available > products_per_slide && products_limit > products_per_slide){
        cellAlign = "left";
      } else {
        cellAlign = "center";
      }

      if (products_available > products_per_slide && products_limit > products_per_slide) {
        draggable = true;
        prevNext = true;
        wrapAround = true;
      } else {
        draggable = false;
        prevNext = false;
        wrapAround = false;
      }

      if (products_per_slide == "2" && products_available > products_per_slide || products_per_slide == "4" && products_available > products_per_slide || products_per_slide == "6" && products_available > products_per_slide){
        initialIndex = 0;
      } else if (products_per_slide == "3" && products_available) {
        initialIndex = 1;
      } else if (products_per_slide == "5" && products_available) {
        initialIndex = 2;
      } else if (products_per_slide == "7" && products_available) {
        initialIndex = 3;
      }

      if ($(window).width() <= 798) {
        cellAlign = "center";
        draggable = true;
        prevNext = true;
        wrapAround = true;
        initialIndex = 1;

        $(this).parents('.even-num-slides').removeClass('even-num-slides');
      }

      $(this).flickity({
        "lazyLoad": 2,
        "imagesLoaded": true,
        "draggable": draggable,
        "prevNextButtons": prevNext,
        "wrapAround": wrapAround,
        "cellAlign": cellAlign,
        "pageDots": usePageDots,
        "contain": true,
        "freeScroll": true,
        "arrowShape": arrowSize,
        "initialIndex": initialIndex
      });

      $(this).addClass('slider-initialized');
    });
  },
  unload: function($target){
    var $slider = $target.find('.js-product-slider');
    if ($slider.hasClass('flickity-enabled')){
      $slider.flickity('destroy');
    }
  }
}

/*============================================================================
  Featured promotions
==============================================================================*/
var featuredPromotions = {
  init: function(){
    if ($(window).width() > 798 || $(window).width() == 0) {
      $('.feature-overlay').hover(function(){
        $(this).find('.feature-details').slideDown('100', function(){
          $(this).addClass('reveal-details');
        });
      }, function(){
        $(this).find('.feature-details').removeClass('reveal-details');
        $(this).find('.feature-details').slideUp('100');
      });

      $('.js-featured-promotions').each(function (index, value){
        var $promos = $(this);
        var animationStyle = $(this).data('promo-animation');

        $promos.waypoint(function() {
          $(this.element).find(".feature-section").addClass("animated " + animationStyle);
        }, { offset: '80%' });
      });
    }
  }
}

/*============================================================================
  Slideshow
==============================================================================*/

var slideshow = {
  init: function(){

    $('.js-homepage-slideshow').each(function (index, value){
      var $homepageSlider = $(this);
      var settings = {
        slideshowSpeed: $homepageSlider.data('slideshow-speed')*1000,
        slideshowTextAnimation: $homepageSlider.data('slideshow-text-animation'),
        adaptiveHeight: $homepageSlider.data('adaptive-height')
      }

      //initiate the slideshow
      if (!$homepageSlider.hasClass('flickity-enabled')){
        var arrowShow = $homepageSlider.find('.gallery-cell').length === 1 ? false : true;
        $homepageSlider.flickity({
                    adaptiveHeight: settings.adaptiveHeight,
                    wrapAround: true,
                    cellAlign: 'left',
                    imagesLoaded: true,
                    prevNextButtons: arrowShow,
                    draggable: arrowShow,
                    pageDots: usePageDots,
                    autoPlay: settings.slideshowSpeed,
                    arrowShape: arrowSize
                  });

        if (settings.slideshowTextAnimation != ''){
          var flkty = $homepageSlider.data('flickity');
          setTimeout(function() {
            $homepageSlider.find('.gallery-cell:nth-child(1) .caption-content').addClass('animated ' + settings.slideshowTextAnimation);
          }, 400);

          $homepageSlider.on( 'select.flickity', function() {
            if($homepageSlider.is(':visible')) {
              var currentSlide = flkty.selectedIndex + 1;
              setTimeout(function() {
                $homepageSlider.find('.caption-content').removeClass('animated ' + settings.slideshowTextAnimation);
                $homepageSlider.find('.gallery-cell:nth-child(' + currentSlide + ') .caption-content').addClass('animated ' + settings.slideshowTextAnimation);
              }, 400);
            }
          });
        }
      }

      if ($homepageSlider.find('.gallery-cell').length > 1) {
        $homepageSlider.addClass('multi-image');
      } else {
        $homepageSlider.addClass('single-image');
      }

      $homepageSlider.find('.gallery-cell').each(function(){
        var buttonWidth = 0;
        $(this).find('.action_button').each(function(){
          $button = $(this);
          if($(this).width() > buttonWidth){
              buttonWidth = $(this).width();
          }
        });
        $(this).find('.action_button').width(buttonWidth);
      });

    });
  },
  unload: function($target){

    var $slider = $target.find('.js-homepage-slideshow');
    $slider.flickity('destroy');

  }
}

/*============================================================================
  Testimonials
==============================================================================*/

var testimonial = {
  init: function(){

    $('.js-testimonial').each(function (index, value){
      var $testimonialSlider = $(this);
      var settings = {
        slideshowSpeed: $testimonialSlider.data('slideshow-speed')*1000,
        slideshowTextAnimation: $testimonialSlider.data('slideshow-text-animation')
      }

      if( $('.testimonial-image').length > 0){
        $('.testimonial-block').each(function(){
          if( $(this).find('.testimonial-image').length == 0){
            var theBlock = $(this).closest('.testimonial-block');
            $(theBlock).addClass('set-testimonial-height');
          }
        })
      }

      //initiate the slideshow
      if (!$testimonialSlider.hasClass('flickity-enabled')){
        var arrowShow = $testimonialSlider.find('.gallery-cell').length === 1 ? false : true;
        $testimonialSlider.flickity({
                        wrapAround: true,
                        cellAlign: 'left',
                        imagesLoaded: true,
                        prevNextButtons: arrowShow,
                        draggable: arrowShow,
                        pageDots: usePageDots,
                        autoPlay: settings.slideshowSpeed,
                        arrowShape: arrowSize
                      });

        if (settings.slideshowTextAnimation != ''){
          var flkty = $testimonialSlider.data('flickity');
          setTimeout(function() {
            $testimonialSlider.find('.gallery-cell:nth-child(1) .caption-content').addClass('animated ' + settings.slideshowTextAnimation);
          }, 400);

          $testimonialSlider.on( 'select.flickity', function() {
            if($testimonialSlider.is(':visible')) {
              var currentSlide = flkty.selectedIndex + 1;
              setTimeout(function() {
                $testimonialSlider.find('.caption-content').removeClass('animated ' + settings.slideshowTextAnimation);
                $testimonialSlider.find('.gallery-cell:nth-child(' + currentSlide + ') .caption-content').addClass('animated ' + settings.slideshowTextAnimation);
              }, 400);
            }
          });
        }
      }

      if ($testimonialSlider.find('.gallery-cell').length > 1) {
        $testimonialSlider.addClass('multi-image');
      } else {
        $testimonialSlider.addClass('single-image');
      }

      $testimonialSlider.find('.gallery-cell').each(function(){
        var buttonWidth = 0;
        $(this).find('.action_button').each(function(){
          $button = $(this);
          if($(this).width() > buttonWidth){
              buttonWidth = $(this).width();
          }
        });
        $(this).find('.action_button').width(buttonWidth);
      });

    });
  },

  unload: function($target){
    var $slider = $target.find('.js-testimonial');

    $slider.flickity('destroy');

  }
}

/*============================================================================
  Gallery
==============================================================================*/

var gallery = {
  init: function(){

    $('.gallery-horizontal').find('.gallery-image-wrapper').each(function(){
      var wrapper = $(this);
      var images = $(this).find("img");
      var imgWidth,
          imgHeight;

      $("<img />").attr("src", $(images).attr("src")).on('load', function() {
        imgWidth = this.width;
        imgHeight = this.height;

        $(wrapper).css("flex-basis", imgWidth * 200 / imgHeight);
        $(wrapper).css("flex-grow", imgWidth * 200 / imgHeight);
        $(wrapper).find("i").css("padding-bottom", imgHeight / imgWidth * 100 + '%');
    });
  });

  $('[rel=gallery]').fancybox({
    baseClass: "gallery-section__lightbox",
    clickContent: "nextOrClose"
  })

  }
}

/*============================================================================
  Video
==============================================================================*/

//check to see if HTML5 video is supported
var supports_video = function(){
  return !!document.createElement('video').canPlayType;
}

var videoSection = {
  init: function(){

    //Initialize lazy videos
    lazyframe('.lazyvideo--autoplay--true', {
      initinview: true,
    });

    lazyframe('.lazyvideo--autoplay--false', {
      initinview: false,
    });

    //Wrap product description iframes in responsive lazyframe div
    $('.product_section .description').find('iframe').wrap('<div class="lazyframe" data-ratio="16:9"></div>');

    function hideTextElements(parent) {
      parent.find('.caption').hide();
      parent.find('.action_button').hide();
    }

    var videoElement = $('.js-video.hide-text-on-video.video-autoplay--true').parents('.js-video-section');
    hideTextElements(videoElement);


    if($('.js-video').hasClass('hide-text-on-video') && $('.js-video').hasClass('video-autoplay--true')){
      var videoSection = $('.js-video').parents('.js-video-section');
      hideTextElements(videoSection);
    }

    $(".video-section .lazyvideo.hide-text-on-video").on('click', function(){
      var videoSection = $(this).parents('.js-video-section');
      hideTextElements(videoSection);
    })

    $('[data-play-video-button], video.hide-text-on-video, .lazyvideo--autoplay--false').on('click', function(){
      //Target parent lazyframe
      var videoSection = $(this).parents('.js-video-section');
      var lazyElement = videoSection.find('.lazyframe');
      var videoWrapper = videoSection.find('.js-video');
      if(videoWrapper.data('mp4') || videoWrapper.data('ogv')) {
        videoSection.find('video')[0].play();
        if(videoSection.find('.js-video.hide-text-on-video').length) {
          hideTextElements(videoSection);
        }
      } else{
        //create iframe and add settings
        var lazyIframe = document.createElement('iframe');
        iframeSrc = lazyElement.data('src');
        cleanIframeSrc = iframeSrc.substring(0, iframeSrc.indexOf('?')) + '?&autoplay=1';
        lazyIframe.src = cleanIframeSrc;
        lazyIframe.setAttribute('allowfullscreen', true);
        lazyIframe.setAttribute('frameborder', 0);
        //Append iframe to lazyframe
        lazyElement.append(lazyIframe);
        if(videoSection.find('.js-video.hide-text-on-video').length) {
          hideTextElements(videoSection);
        }
      }
    });
  },
  unload: function($target){
    $target.find('[data-play-video]').off('click');
    $target.find('video.hide-text-on-video').off('click');
  }
}

/*============================================================================
  Cart
==============================================================================*/
var cart = {
  init: function(){
    if ($('#cart_form .tos_agree').length) {
      //Terms of service on cart page
      $('body').on('click', "#cart_form input[type='submit']", function() {
        if ($(this).parents('form').find('.tos_agree').is(':checked')) {
          $(this).submit();
        } else {
          var warning = '<p class="warning animated bounceIn">' + "Vous devez accepter les termes et conditions à la caisse." + '</p>';
          if ($('p.warning').length == 0) {
            $(this).before(warning);
          }
          return false;
        }
      });
    }

    //Refresh page on add to cart if on cart page
    if($('body').hasClass('cart')) {
      $('.product_form form').on("submit", function(){
        setTimeout(function(){
          document.location.href = "/cart";
        }, 500);
      });
    }

    var OPTION_TRANQUILITE_VARIANT_ID = 36723766591646;
    var MAQUETTE_VARIANT_ID = 39659762647198;
    var WARRANTY_VARIANT_ID = 50607400419657;
    var PRIORITY_VARIANT_ID = 53782612246857;
    

    if ($('.cart-additional-product-cta[data-remove-maquette]').length) {
      removeProductFromCart('maquette', () => addProductToCart(OPTION_TRANQUILITE_VARIANT_ID));
    }

    const cartAdditionals = $('.cart-additional');
    cartAdditionals.click(function(e) {
      const id = $(this).attr('id');

      if ($(this).hasClass('disabled')) {
        e.preventDefault();
        e.stopPropagation();
        return;
      }

      if ($(this).hasClass('active')) {
        removeProductFromCart(id);
      } else {
        $(this).addClass('disabled');
        switch (id) {
          case 'bat':
            addProductToCart(OPTION_TRANQUILITE_VARIANT_ID);
            break;
          case 'maquette':
            if ($(`.cart__row[data-line][data-service="bat"]`).length) {
              removeProductFromCart('bat', () => addProductToCart(MAQUETTE_VARIANT_ID));
            } else addProductToCart(MAQUETTE_VARIANT_ID);
            break;
          case 'priority':
            addProductToCart(PRIORITY_VARIANT_ID);
            break;
          case 'warranty':
            addProductToCart(WARRANTY_VARIANT_ID);
            break;
          default:
            break;
        }
      }
      $(this).toggleClass('active');
      $(this).find('.toggle').toggleClass('on');
    });

    function addProductToCart(variantId, callback = null){
      $.post('/cart/add.js', {
        items: [
          {
            quantity: 1,
            id: variantId
          }
        ],
      }).done(function() {
        if (callback && typeof callback === 'function') callback();
        else location.reload();
      });
    }
    function removeProductFromCart(cartAdditionalId, callback = null){
      const line = $(`.cart__row[data-line][data-service="${cartAdditionalId}"]`).data('line');
      if (!line) return false;
      $.post('/cart/change.js', {
        line,
        quantity: 0
      }).done(function() {
        if (callback && typeof callback === 'function') callback();
        else location.reload();
      });
    }
  }
}

/*============================================================================
  Product
==============================================================================*/
var fallback = "Socle Noir";
var fallbackBig = "Socle Granit Noir";

var unavailableVariants = [
  // { size: "30 x 20 cm", fixing: "Socle Granit Noir", fallback: "Socle Marbre Blanc" },
  // { size: "Livre", fixing: "Socle Granit Noir", fallback: "Socle Marbre Blanc" },

  // { size: "30 x 20 cm", fixing: "Socle Marbre Blanc", fallback: "Socle Granit Noir" },
  // { size: "Livre", fixing: "Socle Marbre Blanc", fallback: "Socle Granit Noir" },

  // { size: "30 x 20 cm", fixing: "Socle Granit Gris", fallback: "Socle Granit Noir" },
  // { size: "Livre", fixing: "Socle Granit Gris", fallback: "Socle Granit Noir" },

  // { size: "21 x 14 cm", fixing: "Socle Granit Noir", fallback: "Socle Noir" },
  // { size: "Coeur", fixing: "Socle Granit Noir", fallback: "Socle Noir" },
  // { size: "Nuage", fixing: "Socle Granit Noir", fallback: "Socle Noir" },

  // { size: "21 x 14 cm", fixing: "Socle Marbre Blanc", fallback: "Socle Granit Noir" },
  // { size: "Coeur", fixing: "Socle Marbre Blanc", fallback: "Socle Granit Noir" },
  // { size: "Nuage", fixing: "Socle Marbre Blanc", fallback: "Socle Granit Noir" },

  // { size: "21 x 14 cm", fixing: "Socle Granit Gris", fallback: "Socle Noir" },
  // { size: "Coeur", fixing: "Socle Granit Gris", fallback: "Socle Noir" },
  // { size: "Nuage", fixing: "Socle Granit Gris", fallback: "Socle Noir" },
];

if (window.fixings && Object.keys(window.fixings).length > 0) {
  Object.entries(window.fixings).map(([key, fixing]) => [key, fixing.variants]).forEach(([key, fixingVariants]) => {
    const findUnavailableVariants = fixingVariants.filter(variant => variant.available === false)
    if (findUnavailableVariants?.length > 0) {
      findUnavailableVariants.forEach(findUnavailableVariant => {
        // console.log(key, findUnavailableVariant)
        unavailableVariants.push({
          size: findUnavailableVariant.option1,
          fixing: findUnavailableVariant.option2,
          fallback: findUnavailableVariant.option1?.includes('30 x 20') ? fallbackBig : fallback,
        })
        if (findUnavailableVariant.option1?.includes('30 x 20')) {
          unavailableVariants.push({
            size: "Livre",
            fixing: findUnavailableVariant.option2,
            fallback: fallbackBig,
          })
        }
        else if (findUnavailableVariant.option1?.includes('21 x 14')) {
          unavailableVariants.push({
            size: "Coeur",
            fixing: findUnavailableVariant.option2,
            fallback: fallback,
          })
          unavailableVariants.push({
            size: "Nuage",
            fixing: findUnavailableVariant.option2,
            fallback: fallback,
          })
        }
      })
    }
  })
}

var unshowVariants = [
  { size: "Livre", fixing: "Vis et cache vis", fallback: "Socle Noir" },
  { size: "Coeur", fixing: "Vis et cache vis", fallback: "Socle Noir" },
  { size: "Ovale", fixing: "Vis et cache vis", fallback: "Socle Noir" },
  { size: "Nuage", fixing: "Vis et cache vis", fallback: "Socle Noir" },
  { size: "Etoile", fixing: "Vis et cache vis", fallback: "Socle Noir" },
  { size: "Double Coeur", fixing: "Vis et cache vis", fallback: "Socle Noir" },
];
var shapesWithNoPremium = ["Ovale", "Etoile", "Double Coeur"]

// Granit out of stock 
var unavailablePDCVariants = [ 
  // { product: "Plaque funéraire Livre sur socle", coloris: ['Juparana'], fallback: "Gris Mass blue" },
  // { product: "Plaque funéraire Cœur fleurs taillées avec vase", coloris: ['Juparana'], fallback: "Gris Mass blue" },
  // { product: "Plaque funéraire Cœur fleurs taillées", coloris: ['Gris Mass blue'], fallback: "Juparana" },
  // { product: "Plaque funéraire Vague élégante sur socle", coloris: ['Juparana', 'Gris Mass blue'], fallback: "Noir Absolu" },
  // { product: "Plaque funéraire Ellipse sur socle", coloris: ['Juparana'], fallback: "Noir absolu" },
  // { product: "Plaque funéraire Cœur sur présentoir", coloris: ['Noir absolu'], fallback: "Gris Mass blue" },
  // { product: "Plaque funéraire Vase et cœur sur socle", coloris: ['Noir absolu', 'Gris Mass blue'], fallback: "Juparana"},
  // { product: "Plaque funéraire Cœur dans le cœur", coloris: ['Noir absolu'], fallback: "Gris Mass blue"},
  // { product: "Plaque funéraire Double cœurs sur socle", coloris: ["Noir absolu", "Gris Mass blue"], fallback: 'Juparana'},
  // { product: "Plaque funéraire Cœur sur socle", coloris: ['Gris Mass blue'], fallback: 'Noir absolu'},
  // { product: "Plaque funéraire Classique sur pieds", coloris: ['Gris Mass blue', 'Juparana'], fallback: "Noir absolu"},
  // { product: "Plaque funéraire Forme mouvementée", coloris: ["Juparana"], fallback: "Noir absolu"},
  // { product: "Plaque funéraire Colombe dans le ciel", coloris: ['Gris Mass blue'], fallback: "Juparana"},
  // { product: "Plaque funéraire Vague élégante sur socle", coloris: ['Noir Absolu'], fallback: "Gris Mass blue" },
  // { product: "Plaque funéraire Petit livre", coloris: ['Juparana'], fallback: "Gris Mass blue" },
  // { product: "Plaque funéraire Médaillon sur présentoir", coloris: ['Gris Mass blue', 'Juparana'], fallback: "Noir absolu" },
  // { product: "Plaque funéraire Cercle sur socle", coloris: ['Gris Mass blue', 'Noir absolu'], fallback: "Juparana" },
  // { product: "Plaque funéraire Présentoir 4 textes", coloris: ['Gris Mass blue'], fallback: "Noir absolu" },
];

selectCallback = function(variant, selector) {

  if (isPdcGranitVendorProduct(selector)) { handlePdcGranitSelectionOfVariant(variant, selector) }
  else if (isPlaqueDecesVendorProduct(selector)) handleSelectionOfVariant (variant, selector)

  function isPdcGranitVendorProduct (selector) {
    return selector && selector.product && selector.product.vendor.match(/PDC granit/g)
  }

  function handlePdcGranitSelectionOfVariant (variant, selector) {
    // handle unavailable options
    var selectedVariant = variant.option1.normalize("NFD").replaceAll(" ", "-").toLowerCase()
    var unavailable = unavailablePDCVariants.find(p => selector.product.title == p.product);
    if(!!unavailable) {
      if (unavailable.coloris) {
        if(typeof unavailable.coloris === "string") { disableColoris(unavailable.coloris, unavailable.fallback) }
        else if(unavailable.coloris.length > 0) { unavailable.coloris.forEach(c => disableColoris(c, unavailable.fallback)) }
      }
    }
    function disableColoris (coloris, fallback="") {
      coloris = coloris.normalize("NFD").replaceAll(" ", "-").toLowerCase()
      fallback = fallback.normalize("NFD").replaceAll(" ", "-").toLowerCase()
      var $colorisSelector = $("#selector-container-" + selector.product.id + "-coloris-" + coloris),
              $outOfStockLabel = $colorisSelector.find('#unavailable-' + coloris),
              $input = $colorisSelector.find('input'),
              $fallback = $("#selector-container-" + selector.product.id + "-coloris-" + fallback +" .overlay-selector");
      $outOfStockLabel.show()
      $input.attr('disabled', true);
      if($fallback && selectedVariant === coloris) setTimeout(function () { $fallback.click(); }, 0);
    }
    // handle slots
    for (var i = 0; i < selector.product.options.length; i++) {
      var option = selector.product.options[i],
              keyName = `option${i + 1}`;
      if (option === 'Coloris') {
        // handle barcode
        var barcodeSelector = $("#barcode-"+selector.product.id);
        barcodeSelector.val(variant.barcode);
      } else if (option.indexOf('Slot ') < 0 || variant[keyName] === 'Sans') { continue; }

      var slotOption = option.replace(' ', '-').toLowerCase(),
              inputName = `option-${i}`;
      handleSelectionOfBronze(slotOption, keyName);

    }

    var interOption = findInterTag(selector.product.tags);

    if (interOption) { handleSelectionOfInterType (interOption) }

    function findInterTag (tags) {
      return tags.find( function(s) {
        return s.match(/[0-9] inter/g)
      })
    }

    function handleSelectionOfInterType (interOption) {

      var interId = 'inter-'+selector.product.id,
              $predefinedSelector = $('#predefined-'+interId+'-selector'),
              $customSelector = $('#custom-'+interId+'-selector'),
              $predefinedInputs = $(".predefined-"+interId+'-input'),
              $customInputs = $(".custom-"+interId+'-input'),
              $predefinedSelectorInput = $("#predefined-"+interId+'-input'),
              $customSelectorInput = $("#custom-"+interId+'-input'),
              $predefinedRefInputs = $(".predefined-ref-"+interId+'-input');

      if(!$._data($predefinedSelector.get(0), "events")) {
        $predefinedSelector.on("click", showPredefinedInter)
        $customSelector.on("click", showCustomInter)
        $customInputs.on("input", function () {
          var $this = $(this);
          $this.val($this.val().replace(/[\u2700-\u27BF]|[\uE000-\uF8FF]|\uD83C[\uDC00-\uDFFF]|\uD83D[\uDC00-\uDFFF]|[\u2011-\u26FF]|\uD83E[\uDD10-\uDDFF]+/g, ""))
          changeInterValue(this.dataset.index, $(this).val()); })
        $predefinedInputs.on("change", function () {
          var $this = $(this);
          changeInterValue(this.dataset.index, $this.val());
          changePredefinedRefValue(this.dataset.index, $this.find(":selected").data('ref'));
        })
      }

      setTimeout( function () {
        if($("#predefined-"+interId+"-input").prop('checked')) { $predefinedSelector.click(); }
        else { $customSelector.click(); }
      }, 0);

      function showCustomInter () {
        $predefinedInputs.hide()
        $predefinedInputs.attr('required', false)
        $customInputs.show()
        $('.options-inter-'+selector.product.id+' .max-char').show()
        $predefinedSelectorInput.attr('checked', false);
        $customSelectorInput.attr('checked', true);
        $customInputs.attr('required', true)
        $customInputs.each(function () {
          changeInterValue(this.dataset.index, $(this).val())
        })
        $predefinedRefInputs.attr('checked', false)
      }

      function showPredefinedInter () {
        $customInputs.hide()
        $customInputs.attr('required', false)
        $predefinedInputs.show()
        $('.options-inter-'+selector.product.id+' .max-char').hide()
        $predefinedSelectorInput.attr('checked', true);
        $customSelectorInput.attr('checked', false);
        $predefinedInputs.attr('required', true)
        $predefinedInputs.each( function () {
          var $this = $(this);
          changeInterValue(this.dataset.index, $this.val());
          changePredefinedRefValue(this.dataset.index, $this.find(":selected").data('ref'));
        })
        $predefinedRefInputs.attr('checked', true)
      }

      function changeInterValue (interIndex, value) {
        $("#"+interId+"-input-"+interIndex).val(value)
      }

      function changePredefinedRefValue (interIndex, ref) {
        $("#predefined-ref-"+interId+"-input-"+interIndex).val(ref)
      }
    }

    function handleSelectionOfBronze (slotOption, keyName) {
      var $bronzeContainer =  $("#bronze-selector-"+selector.product.id+"-"+slotOption+"-container");

      if(!$bronzeContainer.length) return;

      var $modal = $('#bronze-modal-'+selector.product.id+'-'+slotOption),
              $bronzeModalInputs = $('.bronze-input', $modal),
              $optionTitle = $("#bronze-selector-"+selector.product.id+"-"+slotOption+" .option-title"),
              $optionDimensions = $("#bronze-selector-"+selector.product.id+"-"+slotOption+" .option-dimensions"),
              $refInput = $("#bronze-ref-"+selector.product.id+"-"+slotOption+"-input"),
              $bronzeImageSrc = $("#bronze-selector-"+selector.product.id+"-"+slotOption+" .image-selection");

      if(variant[keyName].toLowerCase() === 'bronze') {
        $bronzeContainer.slideDown();
        $bronzeModalInputs.attr('name', 'properties[Type de bronze]');
        $refInput.attr('checked', true);
      } else {
        $bronzeContainer.slideUp();
        $bronzeModalInputs.attr('name', 'type-de-bronze');
        $refInput.attr('checked', false);
      }

      setTimeout(function () { $('.bronze-input:checked', $modal).click(); }, 0);

      if(!$._data($bronzeContainer.get(0), "events")) {
        $bronzeContainer.click(function () {
          $('body').addClass('modal-opened')
          $modal.fadeIn()
        })
        $bronzeModalInputs.click(function () {
          const $this = $(this);
          $optionTitle.text($this.val())
          $optionDimensions.text($this.data('dimensions'))
          $bronzeImageSrc.attr('src', $this.data('src'))
          $refInput.val($this.data('ref'))
        })
      }
    }
  }

  function isPlaqueDecesVendorProduct (selector) {
    return selector && selector.product && selector.product.vendor.match(/Plaque deces/g)
  }

  function handleSelectionOfVariant (variant, selector) {

    const { keyName, inputName } = getFixingProperties(selector)

    if (!variant) return selectFixingFallback(inputName, fallback)

    const { fallback: fallbackForUnavailable } = findUnavailbleFixing(variant.option1, variant[keyName]) || {}
    if (fallbackForUnavailable) return selectFixingFallback(inputName, fallbackForUnavailable)

    setInitialAppearanceState()
    setAppearanceBaseOnShape(variant.option1)

    // Inner function for handling special form selection callback
    function getFixingProperties (selector) {
      const optionIndex = selector.product.options.indexOf("Système de fixation");
      return {
        keyName: `option${optionIndex + 1}`,
        inputName: `option-${optionIndex}`,
      }
    }
    function selectFixingFallback(inputName, inputValue) {
      const selector = `input:radio[name="${inputName}"][value="${inputValue}"]`
      setTimeout(function () { $(selector).click(); }, 0);
    }
    function findUnavailbleFixing(originalSize, originalFixing) {
      return unavailableVariants.filter(function (u) {
        return (
          variant &&
          u.size === originalSize &&
          u.fixing === originalFixing
        );
      })[0];
    }
    function setInitialAppearanceState() {
      $('#hide-special').show()
      $('[id^="unshow-"]').show();
      $('[id^="unavailable-"').hide();
      $('[id^="mok-shape-"]').hide()
    }
    function setAppearanceBaseOnShape (variantShape) {
      $('#mok-shape-' + variantShape.replaceAll(" ", "-").replace('É','E').toLowerCase()).show();
      if (shapesWithNoPremium.includes(variantShape)) $('#hide-special').hide();

      const sameSizeAs = (targetSize) => {
        return ({size}) =>  size === targetSize
      }
      const unshows = unshowVariants.filter(sameSizeAs(variantShape))
      hideUnshowFixing(unshows)
      if ($('.product_form_options').attr('data-product').search(/"vendor":"Plaque deces"/g) > -1) {
        const unavailables = unavailableVariants.filter(sameSizeAs(variantShape))
        toggleUnavailableFixingOverlay(unavailables)
      }
    }
    function hideUnshowFixing (unshows) {
      unshows.forEach(function (u) {
        $('#unshow-' + u.fixing.replaceAll(" ", "-")).hide();
      })
    }
    function toggleUnavailableFixingOverlay (unavailables) {
      unavailables.forEach(function (u) {
        $('#unavailable-' + u.fixing.replaceAll(" ", "-")).show();
      })
    }
  }

  var $product = $('.product-' + selector.product.id);
  var $notify_form = $('.notify-form-' + selector.product.id);
  var $productForm = $('.product_form, .shopify-product-form', $product);
  var variantInventory = $productForm.data('variant-inventory');

  var $notifyFormInputs = $('.notify_form__inputs');

  var notifyEmail = "Saisissez votre adresse e-mail...";
  var notifyEmailValue = "";
  var notifySend = "Envoyer";

  var notifyUrl = $notifyFormInputs.data('url');

  if (variant) {
    var notifyMessage = "Merci de me contacter lorsque "+variant.title+" est disponible à nouveau - "+notifyUrl;
  }

  if ($notifyFormInputs.hasClass('customer--true')) {
    var notifyCustomerEmail = "";
    var notifyEmailInput = '<input type="hidden" class="notify_email" name="contact[email]" id="contact[email]" value="'+ notifyCustomerEmail +'" />'
  } else {
    var notifyEmailInput = '<input required type="email" class="notify_email" name="contact[email]" id="contact[email]" placeholder="'+ notifyEmail +'" value="'+ notifyEmailValue +'" />';
  }
  var notifyFormHTML = notifyEmailInput+'<input type="hidden" name="challenge" value="false" /><input type="hidden" name="contact[body]" class="notify_form_message" data-body="'+ notifyMessage +'" value="'+ notifyMessage +'" /><input class="action_button" type="submit" value="'+ notifySend + '" style="margin-bottom:0px" />';

  //Image Variant feature
  if (variant && variant.featured_image && $product.is(":visible")) {
    var $sliders = $('.js-product-gallery, .js-gallery-modal', $product);
    $sliders.each(function() {
      var $slider = $(this);
      var $sliderInstance = Flickity.data(this);
      if ($slider.is(":visible") && $sliderInstance != undefined ) {
        var index = $('[data-image-id="' + variant.featured_image.id + '"]').data('index');
        $sliderInstance.select( index, false, true );
      }
    });
  }

  if (variant) {
    if (variantInventory) {
      variantInventory.forEach(function(v){
        if (v.id === variant.id) {
          variant.inventory_quantity = v.inventory_quantity;
          variant.inventory_management = v.inventory_management;
          variant.inventory_policy = v.inventory_policy;
        }
      });
    }

    $('.sku span', $product).text(variant.sku);

    
      for (var i=0,length=variant.options.length; i<length; i++) {
        var radioButton = $productForm.find('.swatch[data-option-index="' + escape(i) + '"] :radio[value="' + variant.options[i].replace(/\"/g,'\\"') +'"]');
        if (radioButton.length) {
          radioButton.get(0).checked = true;
        }
      }
    
  }
//Begin
  if (variant && variant.available == true) {
    if(variant.price < variant.compare_at_price){
      $('.was_price', $product).html('<span class="money">' + Shopify.formatMoney(variant.compare_at_price, $('body').data('money-format')) + '</span>');
      $('.savings', $product).html("Économisez" + ' ' + parseInt(((variant.compare_at_price - variant.price) * 100) / variant.compare_at_price) + '% (' + '<span class="money">' + Shopify.formatMoney(variant.compare_at_price - variant.price, $('body').data('money-format')) + '</span>)');
      $('.current_price', $product).parent().addClass('sale');
    } else {
      $('.was_price', $product).html('');
      $('.savings', $product).html('');
      $('.current_price', $product).parent().removeClass('sale');
    }

    if (variant.inventory_management && variant.inventory_quantity > 0) {
      
      
    } else {
      $('.items_left', $product).text('');
      $('.quantity', $product).removeAttr('max');
    }

    $('.sold_out', $product).text('');
    if (variant.price > 0) {
      $('.current_price', $product).html('<span class="money">' + Shopify.formatMoney(variant.price, $('body').data('money-format')) + '</span>');
      $('.free-delivery .gold', $product).html(Shopify.formatMoney(variant.price/3, $('body').data('money-format')))
    } else {
      $('.current_price', $product).html("Gratuit");
    }
    $('.add_to_cart', $product).removeClass('disabled').removeAttr('disabled').find('span').text($('.add_to_cart', $product).data('label'));
    $('.shopify-payment-button', $product).show();
    $notify_form.hide();
    $notifyFormInputs.empty();
  } else {
    var message = variant ? "Épuisé" : "Indisponible";
    $('.was_price', $product).text('');
    $('.savings', $product).text('');
    $('.current_price', $product).text('');
    $('.items_left', $product).text('');
    $('.quantity', $product).removeAttr('max');
    $('.sold_out', $product).text(message);
    $('.add_to_cart', $product).addClass('disabled').attr('disabled', 'disabled').find('span').text(message);
    $('.shopify-payment-button', $product).hide();
    $notify_form.hide();
    $notifyFormInputs.empty();
    if (variant && !variant.available) {
      $notify_form.fadeIn();
      $notifyFormInputs.empty();
      $notifyFormInputs.append(notifyFormHTML);
    }
  }
//End
  
};

var productPage = {
  init: function(){

    var draggable = true;
    var prevNextButtons = true;
    var autoplay = $('.js-product-gallery').data('autoplay');

    setTimeout(function(){
     imageFunctions.linkGalleryAndCarousel($('.js-product-page-gallery .js-product-gallery'), $('.js-product-page-gallery .product_gallery_nav'));
    }, 1000);

    setTimeout(function(){
      resetFormInputData('#votre-demande-specifiez-vos-envies')
      resetFormInputData('#importez-des-fichiers-optionnel')
     }, 500);

    let uploadedFiles = [];

    uploadFileHandler();

    function uploadFileHandler() {
      $('.choosefile-btn').on('click', function(evt) {
        $('#importez-des-fichiers-optionnel').click();
        evt.preventDefault();
        evt.stopPropagation();
      });

      $('#importez-des-fichiers-optionnel').on('input', function(evt) {
        const files = evt.target.files;
        for (let file of files) {
          uploadedFiles.push(file);
          createFileDisplay(file.name);
        }
      });
    }

    function createFileDisplay(fileName) {
      const fileDiv = $(`
        <div class="choosen-file">
          <p class="choosefile-text">${fileName}</p>
          <span class="choosefile-close"> X </span>
        </div>
      `);

      fileDiv.find('.choosefile-close').on('click', function(evt) {
        const index = uploadedFiles.findIndex(file => file.name === fileName);
        if (index > -1) {
          uploadedFiles.splice(index, 1);
          fileDiv.remove();
        }
      });

      $('.choosen-files').append(fileDiv);
      $('.choosefile-close').show()
    }

    function resetFormInputData(selector) {
      $(selector).val('');
      uploadedFiles = [];
      $('.choosen-files').empty();
    }

    // Override the default behavior of the form submit button to handle multiple files upload
    $('.product_form form').on('submit', async function(evt) {
      evt.preventDefault();
      evt.stopPropagation();
      $(".add_to_cart").prop("disabled", true);
      const formData = new FormData();

      // Append all files from the uploadedFiles array to the FormData object.
      uploadedFiles.forEach((file, index) => {
        formData.append(`properties[Importez des fichiers (optionnel) ${index}]`, file);
      });

      // Append other form fields.
      $('input:not([type="file"]):not(:radio):not(:checkbox), select, textarea, input[type="radio"]:checked, input[type="checkbox"]:checked', this).each(function() {
        var name = $(this).attr('name');
        var value = $(this).val();
        if (name && $(this).attr('type') !== 'file') {
          formData.append(name, value);
        }
      });

      try {
        const response = await fetch(evt.target.action, {
          method: 'POST',
          body: formData
        });

        if(response.ok) {
          window.location.href = response.url
        } else {
          if(response.url) {
            window.location.href = response.url
          }
          alert("Une erreur est survenue lors de l'envoi du formulaire. Veuillez réessayer plus tard.")
        }
      } catch (error) {
        // Handle any errors here.
        console.error("Error submitting form:", error);
        alert("Une erreur est survenue lors de l'envoi du formulaire. Veuillez réessayer plus tard.")
      }

      $(".add_to_cart").prop("disabled", false);
    })

    if($('.js-full-width-product-images').length){
      imageFunctions.fullWidth('.product-template .product .description img', '.js-full-width-product-images');
    }

    if ($('.js-product-gallery').hasClass('single-image')){
      draggable = false;
      prevNextButtons = false;
    }

    if(is_touch_device() && $('.js-product-gallery').hasClass('popup-enabled--false')) {
      imageFunctions.zoom('.js-product-gallery');
      draggable = false;
    } else {
      imageFunctions.zoom('.js-product-gallery', false);
    }
    $('.js-product-gallery').css('display', 'block')
    $('.js-product-gallery').flickity({
      "adaptiveHeight": false,
      "wrapAround": "true",
      "cellAlign": "left",
      "draggable": draggable,
      "contain": true,
      "imagesLoaded": true,
      "lazyLoad": 2,
      "pageDots": false,
      "prevNextButtons": prevNextButtons,
      "autoPlay": autoplay ? 6000 : false,
      "dragThreshold": 10,
      "arrowShape": arrowSize
    });

    var groupCells = true;
    var navPrevNextButtons = false;
    var navCellAlign = "center";
    var navWrapAround = false;

    if ($('.product_gallery_nav .gallery-cell').length >= 7) {
      groupCells = false;
      navPrevNextButtons = true;
      navCellAlign = "left";
      navWrapAround = true;
    }
    $('.product-template .product_gallery_nav.product_gallery_nav--bottom-slider').css('display', 'block')
    $('.product-template .product_gallery_nav.product_gallery_nav--bottom-slider').flickity({
      "asNavFor": ".product_gallery",
      "adaptiveHeight": false,
      "wrapAround": navWrapAround,
      "cellAlign": "center",
      "draggable": true,
      "groupCells": groupCells,
      "prevNextButtons":  navPrevNextButtons,
      "pageDots": false,
      "lazyLoad": 2,
      "dragThreshold": 10,
      "arrowShape": arrowSize
    });

    $(".js-product_section .product_form_options").each(function() {
      new Shopify.OptionSelectors($(this).data("select-id"), { product: $(this).data("product"), onVariantSelected: selectCallback, enableHistoryState: $(this).data("enable-state") });
    });

    if (window.location.search === '?contact_posted=true') {
      $('.notify_form .contact-form').hide();
      $('.notify_form .contact-form').prev('.message').html("Merci ! Nous vous contacterons lorsque ce produit sera de nouveau disponible !");
    }

    var $notify_form = $('.notify_form .contact-form');
    $notify_form.each(function() {
      var $nf = $(this);
      $nf.on("submit", function (e) {
        if($('input[name="challenge"]', $nf).val() !== "true") {
          $.ajax({
            type: $nf.attr('method'),
            url: $nf.attr('action'),
            data: $nf.serialize(),
            success: function (data) {
              $nf.fadeOut("slow", function(){
                $nf.prev('.message').html("Merci ! Nous vous contacterons lorsque ce produit sera de nouveau disponible !");
              });
            },
            error: function(data) {
              $('input[name="challenge"]', $nf).val('true');
              $nf.submit();
            }
          });
          e.preventDefault();
        }
      });
    });

    
      
      
        
        $('body').on('click', '.swatch .radio-icon', function() {
          $(this).closest('.swatch-element').prev('input').trigger('click');
        });
      
      $('body').on('change', '.swatch :radio, .swatch select', function() {
        var optionIndex = $(this).closest('.swatch').attr('data-option-index');
        var optionValue = $(this).val();
        var parentForm = $(this).closest('.product_form form');


        if (parentForm.siblings('.notify_form').length){
          var notifyForm = parentForm.siblings('.notify_form');
        } else {
          var notifyForm = $('.js-notify-form');
        }

        var option1 = parentForm.find('.swatch_options input:checked').eq(0).val();
        var option2 = parentForm.find('.swatch_options input:checked').eq(1).val() || '';
        var option3 = parentForm.find('.swatch_options input:checked').eq(2).val() || '';

        if (option1 && option2 && option3){
          var notifyMessage = option1 + ' / ' + option2 + ' / ' + option3;
        } else if (option1 && option2){
          var notifyMessage = option1 + ' / ' + option2;
        } else {
          var notifyMessage = option1;
        }


        notifyForm.find(".notify_form_message").attr("value", notifyForm.find(".notify_form_message").data('body') + " - " + notifyMessage );

        $(this)
          .closest('form')
          .find('.single-option-selector')
          .eq(optionIndex)
          .val(optionValue)
          .trigger('change');
      });
    

    $('.js-product-gallery a').fancybox({
      baseClass: "product-section__lightbox",
      clickContent: false,
      afterShow: function(instance, slide) {
        const zoom = instance.$trigger.first().parents('.js-product-gallery').data('zoom');
        if (zoom){
          $('.fancybox-image')
              .wrap('<span class="zoom-wrap" style="display:inline-block"></span>')
              .css('display', 'block')
              .parent()
              .zoom({
                touch: false,
                magnify: 1
          });
        }
      },
      afterClose: function(instance, slide) {
        const $instanceGallery = instance.$trigger.first().parents('.js-product-gallery');
        $instanceGallery.hide();
        setTimeout(function(){
          $instanceGallery.fadeIn(100);
        }, 1);
      }
    })

    // close modals
    $('.jquery-modal .close-modal').click(function() {
      $(this).closest('.jquery-modal').fadeOut();
      $('body').removeClass('modal-opened')
    })

  },
  productSwatches: function(){
    //Swatches linked with selected options
    
      if ($('.js-product_section').length){
        var $productForms = $('.js-product_section').find('.product_form');
        $productForms.addClass('is-visible');

        //Loop through each product and set the initial option value state

        $productForms.each(function(){
          var JSONData = $(this).data('product');
          var productID = $(this).data('product-id');
          var productSection = '.product-' + productID + ' .js-product_section';
          var swatchOptions = $(this).find('.swatch_options .swatch');
          if (swatchOptions.length > 1){
            Shopify.linkOptionSelectors(JSONData, productSection);
          }
        });
      }

      //Add click event when there is more than one product on the page (eg. Collection in Detail)
      if ($('.js-product_section').length > 1){
        $('body').on('click', '.swatch-element', function(){
          var swatchValue = $(this).data('value').toString();

          $(this)
          .siblings('input[value="'+ swatchValue.replace(/\"/g,'\\"') +'"]')
          .prop("checked", true)
          .trigger("change");

          var JSONData = $(this).parents('.product_form').data('product');
          var productID = $(this).parents('.product_form').data('product-id');
          var productSection = '.product-' + productID + ' .js-product_section';
          var swatchOptions = $(this).parents('.product_form').find('.swatch_options .swatch');

          if (swatchOptions.length > 1){
            Shopify.linkOptionSelectors(JSONData, productSection);
          }
        })
      }
    
  },
  relatedProducts: function(){

    $('.js-related-products-slider .products-slider').each(function (index, value) {
      var products_per_slide = $(this).data('products-per-slide');
      var products_limit = $(this).data('products-limit');
      var products_available = $(this).data('products-available');
      var cellAlign,
          draggable,
          prevNext,
          wrapAround,
          initialIndex;

      if (products_per_slide == "2" && products_available > products_per_slide && products_limit > products_per_slide || products_per_slide == "4" && products_available > products_per_slide && products_limit > products_per_slide || products_per_slide == "6" && products_available > products_per_slide && products_limit > products_per_slide){
        cellAlign = "left";
      } else {
        cellAlign = "center";
      }

      if (products_available > products_per_slide && products_limit > products_per_slide) {
        draggable = true;
        prevNext = true;
        wrapAround = true;
      } else {
        draggable = false;
        prevNext = false;
        wrapAround = false;
      }

      if (products_per_slide == "2" && products_available > products_per_slide || products_per_slide == "4" && products_available > products_per_slide || products_per_slide == "6" && products_available > products_per_slide){
        initialIndex = 0;
      } else if (products_per_slide == "3" && products_available) {
        initialIndex = 1;
      } else if (products_per_slide == "5" && products_available) {
        initialIndex = 2;
      } else if (products_per_slide == "7" && products_available) {
        initialIndex = 3;
      }

      if ($(window).width() <= 798) {
        cellAlign = "center";
        draggable = true;
        prevNext = true;
        wrapAround = true;
        initialIndex = 1;

        $(this).parents('.even-num-slides').removeClass('even-num-slides');
      }

      $(this).flickity({
        "lazyLoad": 2,
        "imagesLoaded": true,
        "draggable": draggable,
        "cellAlign": cellAlign,
        "prevNextButtons": prevNext,
        "wrapAround": wrapAround,
        "pageDots": usePageDots,
        "contain": true,
        "freeScroll": true,
        "arrowShape": arrowSize,
        "initialIndex": initialIndex
      });
    });
  },
  initializeQuantityBox: function(){

    $('body').on('click', '.js-change-quantity', function() {
        var $this = $(this),
            $input = $(this).siblings('input'),
            val = parseInt($input.val()),
            valMax = 100000000000000000000000000000,
            valMin = $input.attr('min') || 0;

        if ($input.attr('max') != null){
          valMax = $input.attr('max');
        }

        if(isNaN(val) || val < valMin) {
            $input.val(valMin);
            return false;
        } else if (val > valMax) {
            $input.val(valMax);
            return false;
        }

        if($this.data('func') == 'plus') {
            if(val < valMax) $input.val(val + 1);
        } else {
            if(val > valMin) $input.val(val - 1);
            if($this.parents(".cart_item").length) {
              if (val - 1 == 0) {
                $this.closest('.cart_item').addClass('animated fadeOutUp')
              }
            }
        }
        $input.trigger('change');

    });
  },
  unload: function($target){

    var $slider = $target.find('.products-slider');
    $slider.flickity('destroy');

  }
}

/*============================================================================
  Header
==============================================================================*/

var header = {
  init: function(){

    window.onscroll = function() {
      var currentScrollPos = window.pageYOffset;
      if (currentScrollPos > 60) {
        $('.slider-informations.top').hide(100);
      } else if (currentScrollPos < 1) {
        $('.slider-informations.top').show(100);
      }
    }

    $('.dropdown_link').on("click", function(e) {
      e.preventDefault();
      e.stopPropagation();
      $(this).parent().parent().parent().find('.mobile-menu').first().toggle();
      $(this).children().toggleClass("open");
      if ($(this).children().hasClass("open")) {
        $('.main_nav_wrapper').addClass('no-shadow');
      } else {
        $('.main_nav_wrapper').removeClass('no-shadow');
      }
    });

    var closeDropdown = function() {
      $('body').removeClass('is-active');
      $('.dropdown_link').removeClass('active_link');
      $('.dropdown_container').hide();
      //$('.mobile_nav').find('div').removeClass('open');
    };

    

    //Vertical menu enabled
    if ($('.dropdown_link--vertical').length){
      $('.dropdown_link--vertical, .vertical-menu_submenu').on('mouseover', function(e) {
        var $dropdown = $(this).parents('.main_nav').find('[data-dropdown="' + $(this).data('dropdown-rel') + '"]');
        var clickCount = $(this).attr('data-click-count');

        $('.active_link').removeClass('active_link');
        if(!$(this).hasClass('active_link')) {
          $(this).children('a').addClass('active_link');
          $('.is-absolute').parent().removeClass('feature_image');
        }
      });

      //Enable touch on parent link if on touch device and desktop menu is visible
      if(is_touch_device()){
        $('.vertical-menu .sublink a, .vertical-menu_submenu .sublink a').on('touchstart click', function(e) {
          e.stopPropagation();

          var verticalMenu = $(this);

          if(e.type == "touchstart") {
            clicked = true;
            if($(this).attr('data-click-count') < 1) {
              openDropdown(verticalMenu);
              e.preventDefault();
            }
          }
          else if(e.type == "click" && !clicked) {
            if($(this).attr('data-click-count') < 1) {
              openDropdown(verticalMenu);
              e.preventDefault();
            }
          }
          else {
            clicked = false;
          }

          function openDropdown(verticalMenu) {

            var $dropdownVertical = $(verticalMenu).next('.vertical-menu_submenu');
            var clickCount = $(verticalMenu).attr('data-click-count');

            $('.dropdown_link--vertical').not(verticalMenu).attr('data-click-count', 0);
            $('.dropdown_link--vertical').attr('data-no-instant', true);
            $('.dropdown_container').hide();

            $('.vertical-menu_submenu').removeClass('is-visible');
            $dropdownVertical.addClass('is-visible');

            //capture touch event
            if (e.type == 'touchstart'){
              clickCount++;
              $(verticalMenu).attr('data-click-count', clickCount);

              if (clickCount < 2){
                e.preventDefault();
                e.stopPropagation();
                return false;
              }
            }
          }
        });
      }
    }

    if ($('.promo_banner').length){
      var promo_banner = Cookies.get('promo_banner');

      if (promo_banner != 'dismiss') {
        $('body').addClass('promo_banner-show');
        $('.promo_banner').on('click', '.promo_banner-close', function(){
          $('body').removeClass('promo_banner-show');
          Cookies.set('promo_banner', 'dismiss', { expires: 30 });
        });
      }
    }

    //offscreen check for menu
    $('.vertical-menu_submenu, .vertical-menu_sub-submenu').each(function() {
      if($(this).is(':off-right')) {
        $(this).addClass('vertical-menu--align-right');
      }
    });

    //Click anywhere outside of dropdown to close
    $('html').on('click', function(event) {
      if (!$(event.target).closest('.cart_container').length && $('.cart_content').is(':visible')) {

        closeMiniCart();
      }

      if (!$(event.target).closest('.dropdown_container').length && $('.dropdown').is(':visible')) {

        closeDropdown();
      }

    });

    //Only apply on larger screen sizes
    //if ($(window).width() > 798) {
    if (true) {
      if ($('.header').hasClass('header-fixed--true')){

        //offset scroll position
        $('body').on('click', '.banner a[href^="#"]', function(e) {
            e.preventDefault();
            var anchorLink = $(this).attr('href');
            var headerHeight = $('.main_nav_wrapper.sticky_nav').outerHeight();
            $('html, body').animate({
              scrollTop: $(anchorLink).offset().top - headerHeight
            }, 2000);
        });

        if ($('.main_nav_wrapper').hasClass('sticky_nav')) {
          var sticky_nav = new Headhesive('.main_nav_wrapper', {
            offset: 700,
            throttle: 300,
            classes: {
              clone: 'sticky_nav',
              stick: 'sticky_nav--stick',
              unstick: 'sticky_nav--unstick'
            },
            onInit: function() {
              $(".sticky_nav .secondary_logo").css('display', 'none');
              $(".sticky_nav .primary_logo").css('display', 'block');
              $(".sticky_nav .icon-search").css('display', 'block');
              
              $(".sticky_nav .nav:last").prepend($(".header .cart_container").clone());
              
            },
            onUnstick: function() {
              
            }
          });
        }
      } else {
        $('.header-fixed--true').removeClass('header-fixed--true');
        if ($('.main_nav_wrapper').length > 1) {
          $('.main_nav_wrapper').first().remove();
        }
      }

      if ($('img.primary_logo:visible')){
        $('.logo img', $(".feature_image .header")).attr('src', $('.logo img').data('src-home'));
      } else {
        $('.logo img').attr('src', $('.logo img').data('src'));
      }
    //Mobile menu
    } else {
      if ($('#header').hasClass('mobile_nav-fixed--true')){
        $('body').addClass('mobile_nav-fixed--true');

        //offset scroll position
        $('body').on('click', '.banner a[href^="#"]', function(e) {
            e.preventDefault();
            var anchorLink = $(this).attr('href');
            var headerHeight = $('#header').outerHeight();
            $('html, body').animate({
              scrollTop: $(anchorLink).offset().top - headerHeight
            }, 2000);
        });
      } else {
        $('body').addClass('mobile_nav-fixed--false');
      }
    }

    //avoid cart_content duplicating
    if($('.cart_content').length <= 2) {
      $('#header .cart_container').append($('.cart_content').clone());
    }


    if ( is_touch_device() || $(window).width() > 0 ) {

      $('.dropdown_link').attr('data-no-instant', true);

      $('body').on('click', '.dropdown_link', function(e) {
        $('.nav a').removeClass('active_link');

        if ($('#header').is(':visible')) {
          var $dropdown = $(this).parents("#header").find('[data-dropdown="' + $(this).data("dropdown-rel") + '"]')

            

        } else {

          if($(this).hasClass("icon-search")) {
            window.location = $(this).attr("href");
            return false;
          }

          var $dropdown = $(this).parents(".main_nav").find('[data-dropdown="' + $(this).data("dropdown-rel") + '"]')
        }

        if ($dropdown.is(':visible') || $dropdown.attr('class') === undefined) {
          $dropdown.hide();
          $('body').removeClass('is-active');
        } else {
          $('.dropdown_container').hide();
          if(!$(this).hasClass('cart_container')) {
            $('.is-absolute').parent().removeClass('feature_image');
          }
          $dropdown.show();
          $('body').addClass('is-active');
          //$('.mobile_nav').find('div').removeClass('open');
        }

        if ($dropdown.is(':visible')) {
          e.stopPropagation();
          return false;
        }
      });

      $('body').on("click", '.mobile_nav', function() {
        //$(this).find('div').toggleClass('open');
      });

      

    } else {


      $(".nav a, .logo a").not(".cart_content a").on("mouseenter", function() {
        if(!$(this).hasClass("active_link")) {
          $('.dropdown_container').hide();
          $('.active_link').removeClass('active_link');
          $('.is-absolute').parent().addClass('feature_image');
        }
      });

      $('.main_nav, .top_bar, .cart_container').on("mouseleave", function() {
        if ( $(window).width() > 798) {
          $('.dropdown_container').hide();
        }
        $('.active_link').removeClass('active_link');
        $('.is-absolute').parent().addClass('feature_image');
      });

      $('.dropdown_link, .dropdown_link--vertical').attr('data-click-count', 0);

      $('.dropdown_link').on('mouseover touchstart', function(e) {
        if ( $(window).width() > 798) {
          $('.dropdown_container').hide();
        }

        var $dropdown = $(this).parents('.main_nav').find('[data-dropdown="' + $(this).data('dropdown-rel') + '"]');
        var clickCount = $(this).attr('data-click-count');

        $('.active_link').removeClass('active_link');

        if(!$(this).hasClass('active_link')) {
          $dropdown.show();

          if($(this).hasClass('mini_cart')) {

              

          } else {

            if ( $(window).width() > 798) {
              $(this).addClass('active_link');
            }

            $('.is-absolute').parent().removeClass('feature_image');
          }
        }


        //Enable touch on parent link if on touch device and desktop menu is visible
        if(is_touch_device()){
          $('.dropdown_link').not(this).attr('data-click-count', 0);
          $('.dropdown_link').attr('data-no-instant', true);


          //capture touch event
          if (e.type == 'touchstart'){
            clickCount++;
            $(this).attr('data-click-count', clickCount);

            if (clickCount < 2){
              e.preventDefault();
              e.stopPropagation();
              return false;
            }
          }
        }


      });


    }


  },
  removeDataAttributes: function(target){
    if($(target).length){
      var i,
          $target = $(target),
          attrName,
          dataAttrsToDelete = [],
          dataAttrs = $target.get(0).attributes,
          dataAttrsLen = dataAttrs.length;

      for (i=0; i<dataAttrsLen; i++) {
        if ( 'data-' === dataAttrs[i].name.substring(0,5) ) {
          dataAttrsToDelete.push(dataAttrs[i].name);
        }
      }
      $.each( dataAttrsToDelete, function( index, attrName ) {
        $target.removeAttr( attrName );
      })
    }
  },

  unload: function() {
    $('body').off('click', '.mobile_nav');
    $('body').off('click', '.dropdown_link');
    $('html').off('click');
    $('.mini_cart').off('click');
    $('.cart_content__continue-shopping').off('click');
    $('body').off('click', '.banner a[href^="#"]');
  }
}

/*============================================================================
  Social media
==============================================================================*/

  var social = {
    twitter: function(){
      if (!window.twttr){
        //Initialize twitter feed
        window.twttr = (function (d,s,id) {
        var t, js, fjs = d.getElementsByTagName(s)[0];
        if (d.getElementById(id)) return; js=d.createElement(s); js.id=id;
        js.src="https://platform.twitter.com/widgets.js";
        fjs.parentNode.insertBefore(js, fjs);
        return window.twttr || (t = { _e: [], ready: function(f){ t._e.push(f) } });
        }(document, "script", "twitter-wjs"));
      }

      if (window.twttr) {
        window.twttr.ready(function (twttr) {
          twttr.widgets.load(
            document.getElementById("twitter-timeline")
          );
        });
      }
    },
    unload: function(){

    }
  }

  var instagram = {
    loadContent: function(s){
      if(s.clientID) {
        var url = 'https://api.instagram.com/v1/users/self/media/recent/?access_token='+s.clientID;

        $.ajax({
          type: 'GET',
          url: url,
          dataType: 'jsonp',
          success: function(data) {

            if(data.meta.code === 200 && data.data.length) {
              var data = data.data;
              var count = 0;
              s.el.empty();

              for(var i = 0; i < data.length; i++) {
                var thisMedia = data[i], item;

                var url = thisMedia.images.low_resolution.url;

                if(!thisMedia.images.low_resolution.url.indexOf("null") > -1) {
                  item = '<div class="il-photo__img instagram__bg" style="background-image:url('+url+')" data-filter="'+thisMedia.filter+'" /></div>';
                  item = '<a href="'+thisMedia.link+'" target="_blank" class="instagram__link">'+item+'</a>';
                }

                if(thisMedia.videos) {
                  item = '<div class="instagram__video instagram__bg" style="background-image:url('+url+')" data-filter="'+thisMedia.filter+'" /></div>';
                  item = '<a href="'+thisMedia.link+'" target="_blank" class="instagram__link instagram__video-link">'+item+'</a>';
                }

                if(item) {
                  item = '<div class="'+s.column+ ' columns instagram__item small-down--one-whole">'+item+'</div>';
                }
                if(item !== '') {
                  s.el.append(item);
                  count++;
                }
                if(count == s.limit) {
                  break;
                }
              }
            }
          },
          error: function() {
          }
        });
      }
    }
  }

  $('.social-feeds-wrap').each(function (index, value) {

    social.twitter();

    var $target = $(this).find(".js-instafeed");
    instagram.loadContent({
      el: $target,
      clientID: $target.data('client-id'),
      limit: $target.data('count'),
      column: $target.data('column')
    });
  });

/*============================================================================
  Map
==============================================================================*/
var mapFunction = {
  init: function() {

    if($('.lazymap').length > 0){
      lazyframe('.lazymap');
    }

    if ($('.maps').hasClass('js-api-map')) {
      var mapsToLoad = [];
      //Create map settings array
      $('.map').each(function(i, obj) {
        mapsToLoad.push(this);
        mapsToLoad[i].sectionid = $(this).data('id');
        mapsToLoad[i].address = $(this).data('address');
        mapsToLoad[i].directions = $(this).data('directions-address');
        mapsToLoad[i].zoom = $(this).data('zoom');
        mapsToLoad[i].mapstyle = $(this).data('style');
        mapsToLoad[i].showpin = $(this).data('pin');
        mapsToLoad[i].apikey = $(this).data('api-key');
      });
      $.each(mapsToLoad, function(i, instance) {
        //Enable caching to avoid duplicate google maps files
        $.ajaxSetup({ cache: true });
        //Load maps script and find location coordinates
        $.getScript(
          'https://maps.googleapis.com/maps/api/js?key=' + mapsToLoad[i].apikey
        ).then(function() {
          mapFunction.findLocation(mapsToLoad[i]);
          $.ajaxSetup({ cache: false });
        });
      });
    }
  },
  findLocation: function(mapArray) {
    var geoLat;
    var geoLng;
    var geocoder = new google.maps.Geocoder();
    //Find and set coordinates
    geocoder.geocode({ address: mapArray.address }, function(results, status) {
      if (status == google.maps.GeocoderStatus.OK) {
        geoLat = results[0].geometry.location.lat();
        geoLng = results[0].geometry.location.lng();
        //Create map
        mapFunction.initMap(geoLat, geoLng, mapArray);
      } else {
        console.log('Error:' + status);
      }
    });
  },
  initMap: function(lat, lng, mapArray) {
    var location = { lat: lat, lng: lng };
    var styleJson = [];
    //Set style JSON
    if(mapArray.mapstyle=='aubergine'){
      styleJson=[{elementType:'geometry',stylers:[{color:'#1d2c4d'}]},{elementType:'labels.text.fill',stylers:[{color:'#8ec3b9'}]},{elementType:'labels.text.stroke',stylers:[{color:'#1a3646'}]},{featureType:'administrative.country',elementType:'geometry.stroke',stylers:[{color:'#4b6878'}]},{featureType:'administrative.land_parcel',elementType:'labels.text.fill',stylers:[{color:'#64779e'}]},{featureType:'administrative.province',elementType:'geometry.stroke',stylers:[{color:'#4b6878'}]},{featureType:'landscape.man_made',elementType:'geometry.stroke',stylers:[{color:'#334e87'}]},{featureType:'landscape.natural',elementType:'geometry',stylers:[{color:'#023e58'}]},{featureType:'poi',elementType:'geometry',stylers:[{color:'#283d6a'}]},{featureType:'poi',elementType:'labels.text.fill',stylers:[{color:'#6f9ba5'}]},{featureType:'poi',elementType:'labels.text.stroke',stylers:[{color:'#1d2c4d'}]},{featureType:'poi.park',elementType:'geometry.fill',stylers:[{color:'#023e58'}]},{featureType:'poi.park',elementType:'labels.text.fill',stylers:[{color:'#3C7680'}]},{featureType:'road',elementType:'geometry',stylers:[{color:'#304a7d'}]},{featureType:'road',elementType:'labels.text.fill',stylers:[{color:'#98a5be'}]},{featureType:'road',elementType:'labels.text.stroke',stylers:[{color:'#1d2c4d'}]},{featureType:'road.highway',elementType:'geometry',stylers:[{color:'#2c6675'}]},{featureType:'road.highway',elementType:'geometry.stroke',stylers:[{color:'#255763'}]},{featureType:'road.highway',elementType:'labels.text.fill',stylers:[{color:'#b0d5ce'}]},{featureType:'road.highway',elementType:'labels.text.stroke',stylers:[{color:'#023e58'}]},{featureType:'transit',elementType:'labels.text.fill',stylers:[{color:'#98a5be'}]},{featureType:'transit',elementType:'labels.text.stroke',stylers:[{color:'#1d2c4d'}]},{featureType:'transit.line',elementType:'geometry.fill',stylers:[{color:'#283d6a'}]},{featureType:'transit.station',elementType:'geometry',stylers:[{color:'#3a4762'}]},{featureType:'water',elementType:'geometry',stylers:[{color:'#0e1626'}]},{featureType:'water',elementType:'labels.text.fill',stylers:[{color:'#4e6d70'}]}]
    }else if(mapArray.mapstyle=='retro'){
      styleJson=[{elementType:'geometry',stylers:[{color:'#ebe3cd'}]},{elementType:'labels.text.fill',stylers:[{color:'#523735'}]},{elementType:'labels.text.stroke',stylers:[{color:'#f5f1e6'}]},{featureType:'administrative',elementType:'geometry.stroke',stylers:[{color:'#c9b2a6'}]},{featureType:'administrative.land_parcel',elementType:'geometry.stroke',stylers:[{color:'#dcd2be'}]},{featureType:'administrative.land_parcel',elementType:'labels.text.fill',stylers:[{color:'#ae9e90'}]},{featureType:'landscape.natural',elementType:'geometry',stylers:[{color:'#dfd2ae'}]},{featureType:'poi',elementType:'geometry',stylers:[{color:'#dfd2ae'}]},{featureType:'poi',elementType:'labels.text.fill',stylers:[{color:'#93817c'}]},{featureType:'poi.park',elementType:'geometry.fill',stylers:[{color:'#a5b076'}]},{featureType:'poi.park',elementType:'labels.text.fill',stylers:[{color:'#447530'}]},{featureType:'road',elementType:'geometry',stylers:[{color:'#f5f1e6'}]},{featureType:'road.arterial',elementType:'geometry',stylers:[{color:'#fdfcf8'}]},{featureType:'road.highway',elementType:'geometry',stylers:[{color:'#f8c967'}]},{featureType:'road.highway',elementType:'geometry.stroke',stylers:[{color:'#e9bc62'}]},{featureType:'road.highway.controlled_access',elementType:'geometry',stylers:[{color:'#e98d58'}]},{featureType:'road.highway.controlled_access',elementType:'geometry.stroke',stylers:[{color:'#db8555'}]},{featureType:'road.local',elementType:'labels.text.fill',stylers:[{color:'#806b63'}]},{featureType:'transit.line',elementType:'geometry',stylers:[{color:'#dfd2ae'}]},{featureType:'transit.line',elementType:'labels.text.fill',stylers:[{color:'#8f7d77'}]},{featureType:'transit.line',elementType:'labels.text.stroke',stylers:[{color:'#ebe3cd'}]},{featureType:'transit.station',elementType:'geometry',stylers:[{color:'#dfd2ae'}]},{featureType:'water',elementType:'geometry.fill',stylers:[{color:'#b9d3c2'}]},{featureType:'water',elementType:'labels.text.fill',stylers:[{color:'#92998d'}]}]
    }else if(mapArray.mapstyle=='silver'){
      styleJson=[{elementType:'geometry',stylers:[{color:'#f5f5f5'}]},{elementType:'labels.icon',stylers:[{visibility:'off'}]},{elementType:'labels.text.fill',stylers:[{color:'#616161'}]},{elementType:'labels.text.stroke',stylers:[{color:'#f5f5f5'}]},{featureType:'administrative.land_parcel',elementType:'labels.text.fill',stylers:[{color:'#bdbdbd'}]},{featureType:'poi',elementType:'geometry',stylers:[{color:'#eeeeee'}]},{featureType:'poi',elementType:'labels.text.fill',stylers:[{color:'#757575'}]},{featureType:'poi.park',elementType:'geometry',stylers:[{color:'#e5e5e5'}]},{featureType:'poi.park',elementType:'labels.text.fill',stylers:[{color:'#9e9e9e'}]},{featureType:'road',elementType:'geometry',stylers:[{color:'#ffffff'}]},{featureType:'road.arterial',elementType:'labels.text.fill',stylers:[{color:'#757575'}]},{featureType:'road.highway',elementType:'geometry',stylers:[{color:'#dadada'}]},{featureType:'road.highway',elementType:'labels.text.fill',stylers:[{color:'#616161'}]},{featureType:'road.local',elementType:'labels.text.fill',stylers:[{color:'#9e9e9e'}]},{featureType:'transit.line',elementType:'geometry',stylers:[{color:'#e5e5e5'}]},{featureType:'transit.station',elementType:'geometry',stylers:[{color:'#eeeeee'}]},{featureType:'water',elementType:'geometry',stylers:[{color:'#c9c9c9'}]},{featureType:'water',elementType:'labels.text.fill',stylers:[{color:'#9e9e9e'}]}]
    }else if(mapArray.mapstyle=='night'){
      styleJson=[{elementType:'geometry',stylers:[{color:'#242f3e'}]},{elementType:'labels.text.fill',stylers:[{color:'#746855'}]},{elementType:'labels.text.stroke',stylers:[{color:'#242f3e'}]},{featureType:'administrative.locality',elementType:'labels.text.fill',stylers:[{color:'#d59563'}]},{featureType:'poi',elementType:'labels.text.fill',stylers:[{color:'#d59563'}]},{featureType:'poi.park',elementType:'geometry',stylers:[{color:'#263c3f'}]},{featureType:'poi.park',elementType:'labels.text.fill',stylers:[{color:'#6b9a76'}]},{featureType:'road',elementType:'geometry',stylers:[{color:'#38414e'}]},{featureType:'road',elementType:'geometry.stroke',stylers:[{color:'#212a37'}]},{featureType:'road',elementType:'labels.text.fill',stylers:[{color:'#9ca5b3'}]},{featureType:'road.highway',elementType:'geometry',stylers:[{color:'#746855'}]},{featureType:'road.highway',elementType:'geometry.stroke',stylers:[{color:'#1f2835'}]},{featureType:'road.highway',elementType:'labels.text.fill',stylers:[{color:'#f3d19c'}]},{featureType:'transit',elementType:'geometry',stylers:[{color:'#2f3948'}]},{featureType:'transit.station',elementType:'labels.text.fill',stylers:[{color:'#d59563'}]},{featureType:'water',elementType:'geometry',stylers:[{color:'#17263c'}]},{featureType:'water',elementType:'labels.text.fill',stylers:[{color:'#515c6d'}]},{featureType:'water',elementType:'labels.text.stroke',stylers:[{color:'#17263c'}]}]}else{styleJson=[]}
    //Create google maps link
    $('.js-map-link').attr(
      'href',
      'https://www.google.com/maps/place/' +
        mapArray.directions +
        '/@' +
        lat +
        ',' +
        lng
    );
    //Set map options
    var mapOptions = {
      zoom: mapArray.zoom,
      center: location,
      styles: styleJson,
      disableDefaultUI: false
    };
    //Create map
    var map = new google.maps.Map(
      document.getElementById(mapArray.sectionid),
      mapOptions
    );
    //Show pin
    if (mapArray.showpin == true) {
      var marker = new google.maps.Marker({
        position: location,
        map: map
      });
    }
  }
};

/*============================================================================
  FAQ
==============================================================================*/
var faqAccordion = {
  init: function(){
    var flg = 0;
    var $faqHeading = $('.faqAccordion > dt > button');
    $('.faqAccordion > dd').attr('aria-hidden',true);
    $faqHeading.attr('aria-expanded',false);
    $faqHeading.on('click activate',function(){
      if( flg ) return false;
      flg = 1;
      var state = $(this).attr('aria-expanded') === 'false' ? true : false;
      $(this).attr('aria-expanded',state);
      $(this).parent().next().slideToggle(function(){
        flg = 0;
      });
        $(this).parent().next().attr('aria-hidden',!state);
      return false;
    });
    $faqHeading.on('keydown',function(event){
      var keyCode = event.keyCode || e.which;
      if (keyCode === 13){
        $(this).trigger('activate');
      }
    });
  }
}


// Options du script - ATTENTION à bien garder les " " pour éviter la catastrophe !
// nombre de phrases souhaitées - choix entre 3 et 6 maximum
dynamicWordNumber = 3;
dynamicWord1 = "la livraison est gratuite";
// 2ere phrase
dynamicWord2 = "les retours sont faciles";
// 3ere phrase
dynamicWord3 = "les paiements sont sécurisés";
// 4ere phrase
dynamicWord4 = "un service après vente de qualité";
// 4ere phrase
dynamicWord5 = "etc..";
// 4ere phrase
dynamicWord6 = "etc";
// ne pas toucher
!function(t){"use strict";var s=function(s,e){this.el=t(s),this.options=t.extend({},t.fn.typed.defaults,e),this.text=this.el.text(),this.typeSpeed=this.options.typeSpeed,this.startDelay=this.options.startDelay,this.backSpeed=this.options.backSpeed,this.backDelay=this.options.backDelay,this.strings=this.options.strings,this.strPos=0,this.arrayPos=0,this.stopNum=0,this.loop=this.options.loop,this.loopCount=this.options.loopCount,this.curLoop=0,this.stop=!1,this.build()};s.prototype={constructor:s,init:function(){var t=this;t.timeout=setTimeout(function(){t.typewrite(t.strings[t.arrayPos],t.strPos)},t.startDelay)},build:function(){this.cursor=t('<span class="typed-cursor">|</span>'),this.el.after(this.cursor),this.init()},typewrite:function(t,s){if(!0!==this.stop){var e=Math.round(70*Math.random())+this.typeSpeed,o=this;o.timeout=setTimeout(function(){var e=0,i=t.substr(s);if("^"===i.charAt(0)){var n=1;i.match(/^\^\d+/)&&(n+=(i=i.replace(/^\^(\d+).*/,"$1")).length,e=parseInt(i)),t=t.substring(0,s)+t.substring(s+n)}o.timeout=setTimeout(function(){if(s===t.length){if(o.options.onStringTyped(o.arrayPos),o.arrayPos===o.strings.length-1&&(o.options.callback(),o.curLoop++,!1===o.loop||o.curLoop===o.loopCount))return;o.timeout=setTimeout(function(){o.backspace(t,s)},o.backDelay)}else 0===s&&o.options.preStringTyped(o.arrayPos),o.el.text(o.text+t.substr(0,s+1)),s++,o.typewrite(t,s)},e)},e)}},backspace:function(t,s){if(!0!==this.stop){var e=Math.round(70*Math.random())+this.backSpeed,o=this;o.timeout=setTimeout(function(){o.el.text(o.text+t.substr(0,s)),s>o.stopNum?(s--,o.backspace(t,s)):s<=o.stopNum&&(o.arrayPos++,o.arrayPos===o.strings.length?(o.arrayPos=0,o.init()):o.typewrite(o.strings[o.arrayPos],s))},e)}},reset:function(){clearInterval(this.timeout);var t=this.el.attr("id");this.el.after('<span id="'+t+'"/>'),this.el.remove(),this.cursor.remove(),this.options.resetCallback()}},t.fn.typed=function(e){return this.each(function(){var o=t(this),i=o.data("typed"),n="object"==typeof e&&e;i||o.data("typed",i=new s(this,n)),"string"==typeof e&&i[e]()})},t.fn.typed.defaults={strings:["These are the default values...","You know what you should do?","Use your own!","Have a great day!"],typeSpeed:0,startDelay:0,backSpeed:0,backDelay:500,loop:!1,loopCount:!1,callback:function(){},preStringTyped:function(){},onStringTyped:function(){},resetCallback:function(){}}}(window.jQuery);
// script génére
if(dynamicWordNumber == 3) {
$(function(){
 $(".change").typed({
 strings: [dynamicWord1, dynamicWord2, dynamicWord3],
 loop: true,
 backDelay: 300,
 typeSpeed: 70
 });
});
}
if(dynamicWordNumber == 4) {
$(function(){
 $(".change").typed({
 strings: [dynamicWord1, dynamicWord2, dynamicWord3, dynamicWord4],
 loop: true,
 backDelay: 300,
 typeSpeed: 70
 });
});
}
if(dynamicWordNumber == 5) {
$(function(){
 $(".change").typed({
 strings: [dynamicWord1, dynamicWord2, dynamicWord3, dynamicWord4, dynamicWord5],
 loop: true,
 backDelay: 300,
 typeSpeed: 70
 });
});
}
if(dynamicWordNumber == 6) {
$(function(){
 $(".change").typed({
 strings: [dynamicWord1, dynamicWord2, dynamicWord3, dynamicWord4, dynamicWord5, dynamicWord6],
 loop: true,
 backDelay: 300,
 typeSpeed: 70
 });
});
}
  $(document).ready(function(){
 $("form label").text(function () {
 return $(this).text().replace("Color", "Couleur");
 });
 $("form label").text(function () {
 return $(this).text().replace("Size", "Taille");
 });
});

/*============================================================================
  DELIVERY ESTIMATION
==============================================================================*/

(function () {

  var initialize = function (moment) {

    moment.fn.easterDay = moment.fn.paques = function (Y) {
      if (Y === undefined) {
        Y = this.year();
      }
      var a = Y % 19;
      var b = Math.floor(Y / 100);
      var c = Y % 100;
      var d = Math.floor(b / 4);
      var e = b % 4;
      var f = Math.floor((b + 8) / 25);
      var g = Math.floor((b - f + 1) / 3);
      var h = (19 * a + b - d - g + 15) % 30;
      var i = Math.floor(c / 4);
      var k = c % 4;
      var l = (32 + 2 * e + 2 * i - h - k) % 7;
      var m = Math.floor((a + 11 * h + 22 * l) / 451);
      var n0 = (h + l + 7 * m + 114);
      var n = Math.floor(n0 / 31) - 1;
      var p = n0 % 31 + 1;
      var date = new Date(Y, n, p);
      return moment(date);
    };

    moment.fn.lundiDePaques = function (Y) {
      if (Y === undefined) {
        Y = this.year();
      }
      return moment.fn.paques(Y).add(1, "days");
    };

    moment.fn.ascension = function (Y) {
      if (Y === undefined) {
        Y = this.year();
      }
      return moment.fn.paques(Y).add(39, "days");
    };

    moment.fn.pentecote = function (Y) {
      if (Y === undefined) {
        Y = this.year();
      }
      return moment.fn.paques(Y).add(50, "days");
    };

    moment.fn.jourDeLAn = function (Y) {
      if (Y === undefined) {
        Y = this.year();
      }
      return moment("1-1-" + Y, "DD-MM-YYYY");
    };

    moment.fn.feteDuTravail = function (Y) {
      if (Y === undefined) {
        Y = this.year();
      }
      return moment("1-5-" + Y, "DD-MM-YYYY");
    };

    moment.fn.victoireDeAllies = function (Y) {
      if (Y === undefined) {
        Y = this.year();
      }
      return moment("8-5-" + Y, "DD-MM-YYYY");
    };

    moment.fn.feteNationale = function (Y) {
      if (Y === undefined) {
        Y = this.year();
      }
      return moment("14-7-" + Y, "DD-MM-YYYY");
    };

    moment.fn.assomption = function (Y) {
      if (Y === undefined) {
        Y = this.year();
      }
      return moment("15-8-" + Y, "DD-MM-YYYY");
    };

    moment.fn.toussaint = function (Y) {
      if (Y === undefined) {
        Y = this.year();
      }
      return moment("1-11-" + Y, "DD-MM-YYYY");
    };

    moment.fn.armistice = function (Y) {
      if (Y === undefined) {
        Y = this.year();
      }
      return moment("11-11-" + Y, "DD-MM-YYYY");
    };

    moment.fn.noel = function (Y) {
      if (Y === undefined) {
        Y = this.year();
      }
      return moment("25-12-" + Y, "DD-MM-YYYY");
    };

    var listeFerie = {
      "Jour de l'an": moment.fn.jourDeLAn,
      "Fête du travail": moment.fn.feteDuTravail,
      "Victoire des alliés": moment.fn.victoireDeAllies,
      "Fête Nationale": moment.fn.feteNationale,
      "Assomption": moment.fn.assomption,
      "Toussaint": moment.fn.toussaint,
      "Armistice": moment.fn.armistice,
      "Noël": moment.fn.noel,
      "Pâques": moment.fn.paques,
      "Lundi de Pâques": moment.fn.lundiDePaques,
      "Ascension": moment.fn.ascension,
      "Pentecôte": moment.fn.pentecote
    };

    moment.fn.getFerieList = function (Y) {
      if (Y === undefined) {
        Y = this.year();
      }

      var res = [];
      for (var key in listeFerie) {
        if (listeFerie.hasOwnProperty(key)) {
          res.push({name: key, date: listeFerie[key](Y) });
        }
      }
      return res;
    };

    moment.fn.getFerie = function () {
      for (var key in listeFerie) {
        if (listeFerie.hasOwnProperty(key)) {
          if (this.isSame(listeFerie[key].call(this), 'days')) {
            return key;
          }
        }
      }
      return null;
    };

    moment.fn.isFerie = function () {
      return (this.getFerie() !== null);
    };

    // Weekend = only Sunday because Chronopost deliver on Saturday
    moment.fn.isWeekEndDelivery = function () {
      return (this.day() === 0);
    };

    // Weekend ADDAXA/Plaquadom = Saturday and Sunday
    moment.fn.isWeekEndAddaxa = function () {
      return (this.day() === 0 || this.day() === 6);
    };

    moment.fn.isWorkingDayDelivery = function () {
      return (!this.isWeekEndDelivery() && !this.isFerie());
    };

    moment.fn.isWorkingDayAddaxa = function () {
      return (!this.isWeekEndAddaxa() && !this.isFerie());
    };

    return moment;
  };

  if (typeof define === "function" && define.amd) {
    define("moment-ferie-fr", ["moment"], function (moment) {
      return this.moment = initialize(moment);
    });
  } else if (typeof module !== "undefined") {
    module.exports = initialize(require("moment"));
  } else if (typeof window !== "undefined" && window.moment) {
    this.moment = initialize(this.moment);
  }

}).call(this);

var deliveryEstimation = {
  COLISOMO_DAY: 2,
  CHRONOPOST_DAY: 1,
  VALIDE_VENDOR: ["Plaque deces", "Plaquadom", "Graniflor", "Fixings"],
  products: [],

  initDeliveryCart: function () {
    this.products = pdcStore.products;
    if(this.products.length > 0){
      this.products = pdcStore.products;
      this._cleanCardsItem();
      var delivery = deliveryEstimation.getEstimatedDelivery();
      document.getElementById('chronopost').innerHTML = delivery.chronopost.format('dddd DD MMM');
      document.getElementById('colissimo-from').innerHTML = delivery.colissimo.from.format('D');
      document.getElementById('colissimo-to').innerHTML = delivery.colissimo.to.format('DD MMM');
    }
  },

  initDeliveryProduct: function () {
    this.products = pdcStore.products;
    var delivery = deliveryEstimation.getEstimatedDelivery();
    $('.delivery-estimate').html(delivery.chronopost.format('dddd DD MMM'));
  },

  getEstimatedDelivery: function () {
    var today = moment();

    if (!today.isWorkingDayAddaxa()) {
      //As long the day is not a working day -> go to the next day
      while (!today.isWorkingDayAddaxa()) {
        today.add(1, "days");
      }
      // Exemple : order on Friday 11pm -> set hours to 0 to be produce before 8am on Monday
      today.hours(0);
    }

    this._addProductionDays(today);

    return {
      colissimo: this._getDateRangeDeliveryColissimo(today),
      chronopost: this._getDateDeliveryChronopost(today),
    };
  },

  _addProductionDays: function (expeditionDate) {
    // production tomorrow if after 8am
    if (expeditionDate.hours() >= 8) {
      this._addDays(expeditionDate, 1, true);
    }
    // 3 days of production for Plaquadom
    if (this._isCartContainsPlaquaDom()) {
      this._addDays(expeditionDate, 2, true);
    }
  },

  _getDateRangeDeliveryColissimo: function (expeditionDate) {
    var from = this._addDays(moment(expeditionDate), this.COLISOMO_DAY); // 48h
    var to = this._addDays(moment(expeditionDate), this.COLISOMO_DAY + 1); // 72h
    return {
      from,
      to,
    };
  },

  _getDateDeliveryChronopost: function (expeditionDate) {
    return this._addDays(moment(expeditionDate), this.CHRONOPOST_DAY);
  },

  _addDays: function (date, nbDays, isWorkingDayAddaxa) {
    while (nbDays > 0) {
      date.add(1, "days");
      var isWorkingDay = isWorkingDayAddaxa
        ? date.isWorkingDayAddaxa()
        : date.isWorkingDayDelivery();
      if (isWorkingDay) {
        nbDays--;
      }
    }
    return date;
  },

  _isCartContainsPlaquaDom: function () {
    return this.products.includes("Plaquadom");
  },

  //Remove bat, maquette etc
  _cleanCardsItem: function () {
    var self = this;
    this.products = this.products.filter(function(product){
      return self.VALIDE_VENDOR.includes(product)
    });
  },
};
